import i18n from '../../i18n'

const noSpace = (v = '') => !/\s/.test(v) || i18n.t('warnings.validation.password_complexity.no_space')
const atLeastEightChars = (v = '') => v.length >= 8 || i18n.t('warnings.validation.password_complexity.at_least_eight_chars')
const specialChar = (v = '') => /\W/.test(v) || i18n.t('warnings.validation.password_complexity.char.special')
const letterChar = (v = '') => /[A-z]/.test(v) || i18n.t('warnings.validation.password_complexity.char.letter')
const numericChar = (v = '') => /\d/.test(v) || i18n.t('warnings.validation.password_complexity.char.numeric')

const passwordComplexityRules = (v) => [
  noSpace(v),
  atLeastEightChars(v),
  letterChar(v),
  specialChar(v),
  numericChar(v)
]

export default passwordComplexityRules
